import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"

export default class ProfileTravelGuideModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.modalJson = elem.dataset.openModal && JSON.parse(elem.dataset.openModal)
    self.elem.link = elem.querySelector(".profile-travel-guide-link")
    self.init()
    return self
  }

  init() {
    const self = this
    self.addEventListeners()
  }

  addEventListeners() {
    const self = this
    if (self.elem.link) {
      self.elem.link.addEventListener("click", (e) => this.handleClickLink(e))
    }
  }

  handleClickLink(e) {
    const self = this
    if (self.elem.modalJson) {
      e.preventDefault()
      Emitter.emit("*", {
        type: emits.REQUEST_CONTENT_MODAL_OPEN,
        modalJson: self.elem.modalJson,
      })
    }
  }
}
